import { client } from "../configs/api-config";

export async function post(url, data) {
  let response = await client.post(url, data);
  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error(response.data);
  }
}

export async function get(url) {    
  let response = await client.get(url);
  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error(response.data);
  }
}
